import { Component } from 'vue-property-decorator';
import {ISalons, ISalonsListItem} from '@/entity/salons/salons.types';
import { SalonsStore } from '@/store/modules/Salons';
import { PaginationMix } from '@/UI/mixins/PaginationMix';
import { mixins } from 'vue-class-component';

@Component
export class SalonsMix extends mixins(PaginationMix) {
    get salons(): ISalons | null {
        return SalonsStore.salons;
    }
    //dataSearch: Array<ISalonsListItem> = [];
    /*scrollPage = 1;
    totalRecords = 0;
    sourceLength = 0;*/


    /*constructDataSearch(): void {
        if (SalonsStore.salons?.data) {
            const items = SalonsStore.salons?.data;
            if (items) {
                items.forEach((item) => {
                    this.dataSearch.push(item);
                });
            }
        }
    }

    async handleSearch(value: string): Promise<void> {
        await SalonsStore.fetchAll({ limit: 10, filter: { name: value } });
        setTimeout(() => {
            if (SalonsStore.salons) {
                let items = [];
                items = SalonsStore.salons.data;
                this.totalRecords = SalonsStore.salons.total;

                this.dataSearch = [];
                items.forEach((item) => {
                    this.dataSearch.push(item);
                });
            }
        }, 500);

    }
    async handleScroll(event: any): Promise<void> {
        const target = event.target;

        if (Number(target.scrollTop) + Number(target.offsetHeight) >= target.scrollHeight) {
            console.log("***");
            if (this.dataSearch.length < this.totalRecords) {
                this.scrollPage = this.scrollPage + 1;
                try {
                    await SalonsStore.fetchAll({
                        skip: this.calcSkipPage(this.scrollPage),
                        limit: this.AppPageParams.pageSize,
                    });
                    this.constructDataSearch();
                } catch (e) {
                    console.log();
                }
                console.log("load");
            }
        }
    }*/

    /*@Watch('salons')
  wSalons(value:any):void {
    //this.AppPageParams.total = this.salons!.total
    this.AppPageParams.total = this.salons!.total
    console.log('warehouse value -'+ value)
    this.tableLoad = true
  }*/
}
